import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { moveGallection, removeGallection, setGallectionName } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import MoveToFolderIcon from '@wix/da-ds/pkg/Icons/24x24/MoveToFolder';
import CameraIcon from '@wix/da-ds/pkg/Icons/24x24/AddCoverImage';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GallectionListMenu from '../GallectionListMenu';
import PromptModal from '../../../Popup/PromptModal';
import { getFolderNameValidationErrorMessage, MAX_TITLE_LENGTH } from '../../../utils/isValidFolderName';
import { isGallectionManageable } from '../../helpers';
import { getSubfoldersByParentId, getFeaturedFolder } from '../../selectors';
import { getCurrentUserHasCore } from '../../../publicSession/selectors';
import { GallectionType } from '../../../types/gallection';
import { isPremiumGallection } from '../../../utils/gallections';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import withGallections from '../../_hocs/withGallections';
import GallectionCoverSelector from '../GallectionCoverSelector';
const enhance = compose(withGallections, connectMediaStore((state, ownProps)=>({
        featuredFolder: getFeaturedFolder(state),
        hasSubfolders: getSubfoldersByParentId(state, ownProps.gallection.folderId).length > 0,
        hasCore: getCurrentUserHasCore(state)
    }), {
    moveGallection,
    removeGallection,
    setGallectionName
}), withTranslation());
export class GallectionControlButtons extends React.Component {
    render() {
        const { className , moreMenuClassName , gallection , t  } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ItemControlButtons, {
            className: className,
            moreMenuClassName: moreMenuClassName,
            menuItems: [
                {
                    // safe zone
                    items: [
                        {
                            value: 1,
                            label: t('mediapopup.itemMenu.rename'),
                            icon: /*#__PURE__*/ React.createElement(EditIcon, {
                                size: IconSize.SMALL
                            }),
                            onClick: this.openRenamePromptPopup
                        },
                        gallection.type !== 'stash' && {
                            value: 1,
                            label: t('mediapopup.itemMenu.changeCover'),
                            icon: /*#__PURE__*/ React.createElement(CameraIcon, {
                                size: IconSize.SMALL
                            }),
                            onClick: this.openCoverSelectionPopup
                        },
                        this.getFolderMoveMenuItem()
                    ].filter((item)=>item)
                },
                {
                    // danger zone
                    items: [
                        {
                            value: 3,
                            label: t('mediapopup.itemMenu.delete'),
                            icon: /*#__PURE__*/ React.createElement(TrashcanIcon, {
                                size: IconSize.SMALL
                            }),
                            danger: true,
                            onClick: this.remove
                        }
                    ]
                }
            ]
        }), this.renderPopup());
    }
    getFolderMoveMenuItem() {
        const _this_props = this.props, { gallection , gallections , featuredFolder , hasCore , hasSubfolders , t  } = _this_props, props = _object_without_properties(_this_props, [
            "gallection",
            "gallections",
            "featuredFolder",
            "hasCore",
            "hasSubfolders",
            "t"
        ]);
        const isSubfolder = !!gallection.parentId;
        const featuredFolderId = featuredFolder && featuredFolder.folderId;
        if ([
            GallectionType.COLLECTION,
            GallectionType.STASH
        ].includes(gallection.type)) {
            return null;
        }
        let label = isSubfolder ? t(`mediapopup.itemMenu.${gallection.type}.moveSubfolder`) : t(`mediapopup.itemMenu.${gallection.type}.moveFolderTo`);
        const isPremium = isPremiumGallection(gallection);
        if (isPremium) {
            var _gallection_premiumFolderData;
            const tooltipTransKey = ((_gallection_premiumFolderData = gallection.premiumFolderData) === null || _gallection_premiumFolderData === void 0 ? void 0 : _gallection_premiumFolderData.type) === 'paid' ? `mediapopup.itemMenu.${gallection.type}.moveFolderTo.tooltip.disabledAsPaid` : `mediapopup.itemMenu.${gallection.type}.moveFolderTo.tooltip.disabledAsWatchersOnly`;
            label = /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
                placement: "right",
                tooltipText: t(tooltipTransKey),
                renderReference: ({ ref  })=>/*#__PURE__*/ React.createElement("span", {
                        style: {
                            pointerEvents: 'all'
                        },
                        ref: ref
                    }, t(`mediapopup.itemMenu.${gallection.type}.moveFolderTo`))
            });
        }
        const isDisabled = !isGallectionManageable(gallection) || // we do not allow more than 1 level of nesting
        // so disallow moving a folder that already has subfolders
        // into another folder
        hasSubfolders || // non-core users can't have subfolders, so a
        // folder can't be moved into a sibling (becoming a sub)
        !hasCore || isPremium;
        return {
            label,
            icon: /*#__PURE__*/ React.createElement(MoveToFolderIcon, {
                size: IconSize.SMALL
            }),
            disabled: isDisabled,
            submenu: !isDisabled && /*#__PURE__*/ React.createElement(GallectionListMenu, {
                // For subfolders, we want to allow moving them one level up
                // and turning them into root-level folders. This is done by moving
                // them to the featuredFolder. Thanks back-end.
                firstItem: isSubfolder && featuredFolderId ? {
                    label: t('mediapopup.itemMenu.moveUp'),
                    value: featuredFolderId
                } : undefined,
                onlyTopLevelFolders: true,
                excludeFolderIds: [
                    gallection.folderId,
                    gallection.parentId,
                    ...!isSubfolder && featuredFolderId ? [
                        featuredFolderId
                    ] : []
                ],
                disableFolderIds: gallections.filter((g)=>!!g.premiumFolderData).map((g)=>g.folderId),
                disableReasonHint: t('mediapopup.itemMenu.gallery.moveFolderTo.tooltip.disabledDueToPremiumDestination'),
                onSelect: (toFolderId)=>props.moveGallection({
                        folderId: gallection.folderId,
                        toFolderId
                    })
            })
        };
    }
    renderPopup() {
        const { gallection , t  } = this.props;
        const { popupType  } = this.state;
        if (!popupType) {
            return null;
        }
        if (popupType === 'rename') {
            return /*#__PURE__*/ React.createElement(PromptModal, {
                isOpen: true,
                title: t(`mediapopup.gallectionMenu.${gallection.type}.prompt.rename.title`),
                inputLabel: t(`mediapopup.gallectionMenu.${gallection.type}.prompt.rename.label`),
                onInputValidate: this.onValidateName,
                initialInputValue: gallection.name,
                onCancel: this.closePopup,
                doneButtonLabel: t('mediapopup.rename'),
                onDone: this.rename,
                maxLength: MAX_TITLE_LENGTH,
                minLength: 1
            });
        } else if (popupType === 'set-cover') {
            return /*#__PURE__*/ React.createElement(GallectionCoverSelector, {
                gallection: gallection,
                onClose: this.closePopup
            });
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            popupType: null
        };
        this.closePopup = ()=>{
            this.setState({
                popupType: null
            });
        };
        this.openRemoveConfirmationPopup = ()=>{
            this.setState({
                popupType: 'remove'
            });
        };
        this.openRenamePromptPopup = ()=>{
            this.setState({
                popupType: 'rename'
            });
        };
        this.openCoverSelectionPopup = ()=>{
            this.setState({
                popupType: 'set-cover'
            });
        };
        this.remove = ()=>{
            const props = this.props;
            props.removeGallection(props.gallection.folderId);
        };
        this.onValidateName = (name)=>{
            const { t , existingGallectionNames , gallection  } = this.props;
            return getFolderNameValidationErrorMessage(name, t, existingGallectionNames, gallection.type === 'gallery');
        };
        this.rename = (name)=>{
            const { gallection: { folderId  }  } = this.props;
            this.props.setGallectionName({
                folderId,
                name
            });
            this.closePopup();
        };
    }
}
export default enhance(GallectionControlButtons);
